/* Swap the big product image to match the chosen Format / Frame colour. */
(function(){
  var COL = { 'Black': 'black', 'White': 'white', 'Natural Wood': 'wood' };
  function txt(m){ var src = m.src || (m.preview_image && m.preview_image.src) || ''; return ((m.alt || '') + ' ' + src.split('?')[0].split('/').pop()).toLowerCase(); }
  function findMedia(media, fmt, col){
    if (fmt === 'u') return media.find(function(m){ return /\bunframed\b|rolled|\broll\b/.test(txt(m)); });
    var k = COL[col] || 'black';
    return media.find(function(m){ return new RegExp('cts[_-]' + k).test(txt(m)); })
      || media.find(function(m){ return new RegExp('framed[ _-]' + k).test(txt(m)); })
      || media.find(function(m){ return new RegExp('(^|[^a-z])' + k + '[-_]').test(txt(m)); });
  }
  function show(wrap, id){
    var slide = wrap.querySelector('[data-slide="' + id + '"]'); if (!slide) return;
    var thumb = wrap.querySelector('[data-thumb="' + id + '"]');
    wrap.querySelectorAll('[data-slide]').forEach(function(s){ s.classList.toggle('is-active', s === slide); });
    wrap.querySelectorAll('[data-thumb]').forEach(function(t){ t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    var img = slide.querySelector('img'); if (img) { img.loading = 'eager'; }
    var stage = slide.parentElement;
    if (stage && stage.scrollWidth > stage.clientWidth + 4) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
  }
  var last = {};
  document.addEventListener('vp:change', function(e){
    var vp = e.target, wrap = vp.closest('[data-product]'); if (!wrap) return;
    var fmt = vp.dataset.fmt, col = vp.dataset.col; if (!fmt) return;
    var key = fmt + '|' + col; if (last[wrap.dataset.section] === key) return; last[wrap.dataset.section] = key;
    var product; try { product = JSON.parse(wrap.querySelector('[data-product-json]').textContent); } catch (err) { return; }
    var m = findMedia(product.media || [], fmt, col);
    if (m) show(wrap, m.id);
  });
})();
